module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/line-9f9b4b656ad0ea8b02d5c2ebd9b9d83d.svg&quot;;"